import DownChevron from 'assets/down-chevron.svg?react'
import {
  AccordionContent,
  AccordionHeader,
  AccordionTriggerPrimitive as AccordionTrigger,
} from 'components/Accordion'
import styled from 'styled-components'
import { GeckoMarkupLayer } from 'types'

export interface LayerGroup {
  layers: GeckoMarkupLayer[]
  subgroups: { [key: string]: LayerGroup }
}

export const ChevronIcon = styled(DownChevron)`
  transition: transform 300ms ease-in-out;
`

export const StyledAccordionHeader = styled(AccordionHeader)`
  width: 100%;
  height: 2.5rem;
  align-items: center;

  &[data-state='closed'] ${ChevronIcon} {
    transform: rotate(0deg);
  }

  &[data-state='open'] ${ChevronIcon} {
    transform: rotate(180deg);
  }
`

export const StyledAccordionTrigger = styled(AccordionTrigger)`
  width: 100%;
  align-content: center;
  margin-left: 0.5rem;
  gap: 0.5rem;
  justify-content: center;

  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.forecast.defaultText};
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:active {
    color: ${({ theme }) => theme.forecast.activeText};
    background-color: ${({ theme }) => theme.forecast.background3};
  }
`

export const StyledAccordionContent = styled(AccordionContent)`
  margin-left: 1rem;
`
